import { COMMON } from "../../util/localizations"

const TRANSLATIONS = {
    en: {
        addInformation: 'Add Information',
        cancel: COMMON.en.cancel,
        commit: 'Commit Changes',
        delete: 'I understand',
        evidence: COMMON.en.evidence,
        instructions: `Clicking the, "{0}" button below will permanently delete this node and all of its connections. You will not be able to undo this action.`,
        name: 'Name',
        note: 'Any information that is left blank will be removed after committing. If you wish to remove a piece of information, delete its contents and commit.',
        title: 'Modify "{0}"',
        warning: 'Please read before continuing',
        ...COMMON.en.shared,
        ...COMMON.en.eventData,
        ...COMMON.en.organizationData,
        ...COMMON.en.personData,
        ...COMMON.en.placeData 
    }
}

export default TRANSLATIONS